module.exports = __webpack_public_path__ + "img/blog-new.e5c523a1.png";